import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DatePicker from '@commonComponents/formComponents/CustomDatePicker'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'

const InvoiceSummary = ({
  dataSource: {
    invoiceNumber,
    invoiceDate,
    poNo,
    invoiceTotal,
    grossMass,
    netMass,
    exchangeRate,
    packQuantity,
    currency,
    deliveryTerms,
    natureOfTransaction=''
  },
  id,
}) => {
  const isDisabled = true;
  const { version, isImportShipment ,serviceType} = useCurrentShipmentType()	
  const isDMS = version === 'DMS'
  return (
    <Grid className='responsiveGridCss'>
      <Grid.Row>
        <Grid.Column width='2'>
          <InputField
            id={`INVOICE_NUMBER${id}`}
            type='text'
            label="INVOICE_NUMBER"
            value={invoiceNumber}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <DatePicker
            id={`INVOICEDATE${id}`}
            type='date'
            label="INVOICE_DATE"
            value={invoiceDate}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`PO/ SHIPMENT ID${id}`}
            type='text'
            label="PO_SHIPMENT"
            value={poNo}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`InvoiceValue${id}`}
            type='text'
            label="INV_TOT_VAL"
            boxNumber={`${isDMS ? '4/11' : ''}`}
            value={invoiceTotal}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`currencys${id}`}
            type='text'
            label="CURRENCY"
            boxNumber={`${isDMS ? '4/10' : ''}`}
            value={currency}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`exchgRate${id}`}
            type='text'
            label="EXCHANGE_RATE"
            boxNumber={`${isDMS ? '4/15' : ''}`}
            value={exchangeRate}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`gross${id}`}
            type='text'
            label="GROSS"
            value={grossMass}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`net${id}`}
            type='text'
            label="NET"
            value={netMass}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`pkqty${id}`}
            type='text'
            label="PACK_QTY"
            value={packQuantity}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`term${id}`}
            type='text'
            label="TERMS"            
            boxNumber={`${isDMS ? '4/1' : ''}`}
            value={deliveryTerms?.incoTerms}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`places${id}`}
            type='text'
            label="PLACE"
            value={deliveryTerms?.place}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`countries${id}`}
            type='text'
            label="COUNTRY"
            value={deliveryTerms?.country}
            clearInput={false}
            isDisabled={isDisabled}
          />
        </Grid.Column>
        {isImportShipment ? (	
          <Grid.Column width='2'>	
            <InputField	
              id={`transaction${id}`}	
              label="TEXT"	
              value={deliveryTerms?.description}	
              clearInput={false}	
              isDisabled={isDisabled}	
            />	
          </Grid.Column>	
        ) : (	
          <Grid.Column width='2'>	
            <InputField	
              id={`natureOfTransaction${id}`}	
              label={'NATURE_OF_TRANSACTION'}	
              boxNumber='8/5'	
              value={natureOfTransaction}	
              clearInput={false}	
              isDisabled={isDisabled}	
            />	
          </Grid.Column>	
        )}
      </Grid.Row>
    </Grid>
  )
}
export default InvoiceSummary